/*
 sohel 10/06/2022 2701251212  Record Format  -> Add New Rule Group ->Fixed Route Issue
 sohel 10/06/2022 2701326866  Record Format ->Map Variables ->Search Table Payload Changes, Catagory
*/
import React, {useEffect, useState, useContext} from 'react';
import {Form, Formik} from 'formik';
import {Button, FormHelperText, TextField} from '@material-ui/core';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from '../../../../../components/PageLoader';
import * as Yup from 'yup';
import {
  getTableName,
  getTableFieldName,
} from '../../../../../redux/reducers/GlobalField/GlobalField';
import {getLetterConstant} from '../../../../../redux/reducers/LetterMaintainance/LetterSummary';
import {getBaseCategory} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import RecordFormatFieldSearchTable, {getFields} from './RecordFormatFieldSearchTable';
import TempVariablesTable from './TempVariablesTable';
import {useHistory} from 'react-router';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';

const FieldSearch = ({setSearchData, searchData, setSelectedRows, selectedRows}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const {baseCategoryData} = useSelector(({addFieldList}) => addFieldList);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const initialValues = {
    category: '',
    displayName: '',
    globalField: '',
    description: '',
    tableName: '',
    tableField: '',
    fieldType: '',
    code: '',
    tableFieldName: '',
    returnType: '',
    tempVariable: '',
  };

  const returnTypes = [
    {key: 'String', value: 'String'},
    {key: 'Number', value: 'Number'},
    {key: 'Boolean', value: 'Boolean'},
    {key: 'Amount', value: 'Amount'},
    {key: 'Date', value: 'Date'},
    {key: 'Phone', value: 'Phone'},
    {key: 'SSN', value: 'SSN'},
    {key: 'Email', value: 'Email'},
  ];

  const handleSubmit = (data, {resetForm}) => {
    if (fieldType === 'Temp Variables') {
      setTempVariablesTableData([
        ...tempVariablesTableData,
        {
          tempVariable: 'TMP' + data.tempVariable,
          tableData: {checked: true, id: 'TMP' + data.tempVariable},
        },
      ]);
      setSelectedRows([
        ...selectedRows,
        {
          fieldCode: 'TMP' + data.tempVariable,
          tableData: {checked: true, id: 'TMP' + data.tempVariable},
          fieldType: 'Temp Variables',
          ...getFields({fieldCode: 'TMP' + data.tempVariable}),
          description: 'TMP' + data.tempVariable,
        },
      ]);
      resetForm();
    } else {
      setSearchData(data);
      setSubmit(true);
    }
  };
  const fieldTypeOptions = [
    {key: 'Global Field', value: 'Global Field'},
    {key: 'BRE Group', value: 'BRE Group'},
    {key: 'Constants', value: 'Constants'},
    {key: 'Temp Variables', value: 'Temp Variables'},
  ];
  const [fieldType, setFieldType] = useState('Global Field');
  const [globalFieldName, setGlobalFieldName] = useState('');
  const [globalFieldCode, setGlobalFieldCode] = useState('');
  const [tempVariablesTableData, setTempVariablesTableData] = useState([]);
  const [submit, setSubmit] = useState(false);
  const {tableNameData, tableFieldNameData, isLoading} = useSelector(
    ({globalField}) => globalField,
  );
  useEffect(() => {
    if (fieldType === 'Constants') {
      dispatch(getLetterConstant());
    }
  }, [fieldType]);
  const validationSchema = Yup.object().shape({
    tempVariable:
      fieldType === 'Temp Variables' &&
      Yup.string().notOneOf(
        tempVariablesTableData.map((data) => data.tempVariable.substring(3)),
        'TempVariable already added',
      ),
    globalField: Yup.string().matches(
      /^[a-zA-Z0-9]+$/,
      'White space and special character are not allowed',
    ),
  });
  const handleReset = (values) => {
    setSearchData(initialValues);
  };

  const onClear = () => {
    const data = {
      category: '',
      displayName: '',
      globalField: '',
      description: '',
      tableName: '',
      tableField: '',
      fieldType: '',
      code: '',
      tableFieldName: '',
      returnType: '',
      tempVariable: '',
    };
    setSearchData(data);
  };
  useEffect(() => {
    dispatch(getBaseCategory());
  }, []);
  return (
    <div className="col-md-12">
      <div>
        <Formik
          onSubmit={handleSubmit}
          initialValues={initialValues}
          enableReinitialize
          onReset={() => handleReset()}
          validationSchema={validationSchema}
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleReset,
              handleBlur,
              setFieldValue,
              touched,
              errors,
            } = props;
            return (
              <div>
                <Form autoComplete="off" noValidate>
                  <div>
                    <ErrorBoundaryForComponents>
                      <div className="form-row">
                        <div className="col-xs-6 col-md-4 form-group">
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name="fieldType"
                            id="fieldType"
                            size="small"
                            value={fieldType ? fieldType : values.fieldType}
                            options={fieldTypeOptions.map((each) => each.key)}
                            required
                            onChange={(e, value) => {
                              if (value) {
                                setFieldType(value);
                                setFieldValue('fieldType', value);
                                setFieldValue('code', '');
                                setFieldValue('displayName', '');
                                setFieldValue('tableField', '');
                                setFieldValue('tableFieldName', '');
                                setFieldValue('tableName', '');
                                setFieldValue('category', '');
                              } else {
                                setFieldValue('fieldType', '');
                              }
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  error={touched.fieldType && errors.fieldType}
                                  variant="outlined"
                                  margin="dense"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  label="Field Type"
                                  placeholder="Select Field Type"
                                  className={` ${classes.labelName} ${classes.selectLabel}`}
                                />
                              </div>
                            )}
                          />
                          <FormHelperText style={{color: 'red'}}>
                            {touched.fieldType && errors.fieldType && errors.fieldType}
                          </FormHelperText>
                        </div>
                        {fieldType === 'Global Field' && (
                          <>
                            <div className="col-xs-6 col-md-4 form-group">
                              <GuiAutoComplete
                                classes={{
                                  option: classes.option,
                                }}
                                name="category"
                                id="category"
                                size="small"
                                value={values.category}
                                options={baseCategoryData}
                                getOptionLabel={(option) => {
                                  return option && option.categoryName ?
                                    option.categoryCode === null ?
                                      option.categoryName :
                                      option.categoryCode + ' - ' + option.categoryName :
                                    '';
                                }}
                                required
                                onChange={(e, value) => {
                                  if (value) {
                                    setFieldValue('category', value);
                                    dispatch(getTableName(value?.categoryCode));
                                  } else {
                                    setFieldValue('category', '');
                                  }
                                }}
                                renderInput={(params) => (
                                  <div className="select-field">
                                    <GuiTextField
                                      {...params}
                                      error={touched.category && errors.category}
                                      variant="outlined"
                                      margin="dense"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      label="Category"
                                      placeholder="Select Category"
                                      className={` ${classes.labelName} ${classes.selectLabel}`}
                                    />
                                  </div>
                                )}
                              />
                              <FormHelperText style={{color: 'red'}}>
                                {touched.category && errors.category && errors.category}
                              </FormHelperText>
                            </div>
                            <div className="col-xs-6 col-md-4 form-group">
                              <TextField
                                margin="dense"
                                variant="outlined"
                                placeholder="Enter Global Field Name"
                                label="Global Field Name"
                                className={` ${classes.labelName} ${classes.inputLabel}`}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                name="displayName"
                                value={values.displayName}
                                onChange={(e, value) => {
                                  handleChange(e);
                                  setFieldValue('displayName', e.target.value);
                                  setGlobalFieldName(e.target.value);
                                }}
                                onBlur={handleBlur}
                                fullWidth
                              />
                            </div>
                            <div className="col-xs-6 col-md-4 form-group">
                              <TextField
                                margin="dense"
                                variant="outlined"
                                placeholder={`Enter Global Field Code`}
                                label="Global Field Code"
                                className={` ${classes.labelName} ${classes.inputLabel}`}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                name="globalField"
                                error={Boolean(touched?.globalField && errors?.globalField)}
                                value={values?.globalField?.toUpperCase()}
                                onChange={(e, value) => {
                                  handleChange(e);
                                  setFieldValue('globalField', e.target.value);
                                  setGlobalFieldCode(e.target.value);
                                }}
                                onBlur={handleBlur}
                                fullWidth
                              />
                              <FormHelperText style={{color: 'red'}}>
                                {touched.globalField && errors.globalField ?
                                  errors?.globalField :
                                  ''}
                              </FormHelperText>
                            </div>
                            <div className="col-xs-6 col-md-4 form-group">
                              <GuiAutoComplete
                                classes={{
                                  option: classes.option,
                                }}
                                name="tableName"
                                id="tableName"
                                size="small"
                                value={values.tableName}
                                options={tableNameData}
                                required
                                disabled={values?.category === ''}
                                onChange={(e, value) => {
                                  if (value) {
                                    setFieldValue('tableName', value);
                                    dispatch(getTableFieldName(value));
                                  } else {
                                    setFieldValue('tableName', '');
                                  }
                                }}
                                renderInput={(params) => (
                                  <div className="select-field">
                                    <GuiTextField
                                      {...params}
                                      error={touched.tableName && errors.tableName}
                                      variant="outlined"
                                      margin="dense"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      label="Table Name"
                                      placeholder="Select Table Name"
                                      className={` ${classes.labelName} ${classes.selectLabel}`}
                                    />
                                  </div>
                                )}
                              />
                              <FormHelperText style={{color: 'red'}}>
                                {touched.tableName && errors.tableName && errors.tableName}
                              </FormHelperText>
                            </div>
                            <div className="col-xs-6 col-md-4 form-group">
                              <GuiAutoComplete
                                classes={{
                                  option: classes.option,
                                }}
                                name="tableFieldName"
                                id="tableFieldName"
                                size="small"
                                value={values.tableFieldName}
                                options={tableFieldNameData}
                                required
                                disabled={!values?.tableName}
                                onChange={(e, value) => {
                                  if (value) {
                                    setFieldValue('tableFieldName', value);
                                  } else {
                                    setFieldValue('tableFieldName', '');
                                  }
                                }}
                                renderInput={(params) => (
                                  <div className="select-field">
                                    <GuiTextField
                                      {...params}
                                      variant="outlined"
                                      margin="dense"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      label="Table Field Name"
                                      placeholder="Select Table Field Name"
                                      className={` ${classes.labelName} ${classes.selectLabel}`}
                                      error={touched.tableFieldName && errors.tableFieldName}
                                    />
                                  </div>
                                )}
                              />
                              <FormHelperText style={{color: 'red'}}>
                                {touched.tableFieldName &&
                                  errors.tableFieldName &&
                                  errors.tableFieldName}
                              </FormHelperText>
                            </div>
                            <div className="col-xs-6 col-md-4 form-group">
                              <TextField
                                margin="dense"
                                variant="outlined"
                                placeholder="Enter Description"
                                label="Description"
                                className={` ${classes.labelName} ${classes.inputLabel}`}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                name="description"
                                value={values.description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                fullWidth
                              />
                            </div>
                            <div className=" mt-2">
                              <Button
                                variant="contained"
                                type="submit"
                                className={`themeing-buttons  ${classes.buttonRoot}`}
                                disabled
                              >
                                Add New Global Field
                              </Button>
                            </div>
                          </>
                        )}
                        {fieldType === 'BRE Group' && (
                          <>
                            <div className="col-xs-6 col-md-4 form-group">
                              <TextField
                                margin="dense"
                                variant="outlined"
                                placeholder={`Enter Formula BRE Group Code`}
                                label="BRE Formula Group Code"
                                className={` ${classes.labelName} ${classes.inputLabel}`}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                name="code"
                                value={values.code}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                fullWidth
                              />
                            </div>
                            <div className="col-xs-6 col-md-4 form-group">
                              <TextField
                                margin="dense"
                                variant="outlined"
                                placeholder={`Enter BRE Formula Description`}
                                label="BRE Formula Description"
                                className={` ${classes.labelName} ${classes.inputLabel}`}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                name="description"
                                value={values.description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                fullWidth
                              />
                            </div>
                            <div className="col-xs-6 col-md-4 form-group">
                              <TextField
                                margin="dense"
                                variant="outlined"
                                placeholder="Enter Formula Display Name"
                                label="Formula Display Name"
                                className={` ${classes.labelName} ${classes.inputLabel}`}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                name="displayName"
                                value={values.displayName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                fullWidth
                              />
                            </div>
                            <div className="col-xs-6 col-md-4 form-group">
                              <GuiAutoComplete
                                classes={{
                                  option: classes.option,
                                }}
                                {...props}
                                id="returnType"
                                options={returnTypes.map((item) => item.value)}
                                size="small"
                                autoHighlight
                                renderInput={(params) => (
                                  <GuiTextField
                                    className={` ${classes.labelName} ${classes.selectLabel}`}
                                    {...params}
                                    variant="outlined"
                                    fullWidth
                                    label="Return Type"
                                    name="returnType"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    error={errors.returnType}
                                    placeholder="Select Return Type"
                                    inputProps={{
                                      ...params.inputProps,
                                      autoComplete: 'off',
                                    }}
                                  />
                                )}
                                onChange={(e, value) => {
                                  setFieldValue('returnType', value);
                                }}
                              />
                            </div>
                            <div className="mt-2">
                              <Button
                                variant="contained"
                                type="submit"
                                className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
                                onClick={() => history.push('/frameworks/BRE')}
                              >
                                Add New Rule Group
                              </Button>
                            </div>
                          </>
                        )}
                        {fieldType === 'Temp Variables' && (
                          <>
                            <div className="col-xs-6 col-md-4 form-group">
                              <TextField
                                margin="dense"
                                variant="outlined"
                                placeholder={`Enter Temp Variable`}
                                label="Temp Variable"
                                className={` ${classes.labelName} ${classes.inputLabel}`}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                name="tempVariable"
                                value={values.tempVariable}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                fullWidth
                              />
                              <FormHelperText style={{color: 'red'}}>
                                {touched.tempVariable && errors.tempVariable && errors.tempVariable}
                              </FormHelperText>
                            </div>
                          </>
                        )}
                      </div>
                    </ErrorBoundaryForComponents>
                  </div>
                  {fieldType === 'Temp Variables' ? (
                    <div className="button-table-spacing-mb">
                      <Button
                        variant="contained"
                        className={`mx-1 ${classes.buttonRoot}`}
                        onClick={() => {
                          handleReset();
                          setFieldType('Global Field');
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        type="submit"
                        className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
                      >
                        Add
                      </Button>
                    </div>
                  ) : (
                    <div className="button-table-spacing-mb">
                      <Button
                        variant="contained"
                        className={`mx-1 ${classes.buttonRoot}`}
                        onClick={() => {
                          handleReset();
                          setFieldType('Global Field');
                          setGlobalFieldCode('');
                          setGlobalFieldName('');
                          onClear();
                          setSubmit(true);
                        }}
                      >
                        Clear
                      </Button>
                      <Button
                        variant="contained"
                        type="submit"
                        className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
                      >
                        Search
                      </Button>
                    </div>
                  )}
                </Form>
                {isLoading && <PageLoader />}
              </div>
            );
          }}
        </Formik>
      </div>

      {fieldType === 'Temp Variables' ? (
        <TempVariablesTable
          tempVariablesTableData={tempVariablesTableData}
          setTempVariablesTableData={setTempVariablesTableData}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
        />
      ) : (
        <RecordFormatFieldSearchTable
          searchData={searchData}
          setSelectedRows={setSelectedRows}
          selectedRows={selectedRows}
          fieldType={fieldType}
          globalFieldCode={globalFieldCode}
          globalFieldName={globalFieldName}
          submit={submit}
          setSubmit={setSubmit}
        />
      )}
    </div>
  );
};

export default FieldSearch;
